import { createStore } from "jotai";

import { Provider } from "jotai/react";

import { memo } from "react";

import { Toaster } from "sileo";

import "./internalization";

import Routes from "./Routes";

import { CustomTitleBar } from "./components/CustomTitleBar/CustomTitleBar";

import { ErrorBoundary } from "./components/ErrorBoundary";

import { OfflineBanner } from "./components/OfflineBanner";

import { PWAUpdatePrompt } from "./components/PWAUpdatePrompt";

const store = createStore();

const Root = () => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <Toaster
          position="bottom-right"
          options={{
            fill: "#1e1e2e",
            styles: { description: "color: #e0e0e0" },
          }}
        />
        <OfflineBanner />
        <PWAUpdatePrompt />
        <CustomTitleBar />
        <Routes />
      </Provider>
    </ErrorBoundary>
  );
};

export default memo(Root);
